import React from 'react';

import { UnfilledSummaryAppointment } from '../../interfaces';
import {
  MY_PATIENTS,
  MY_PATIENTS_BIO_INFO,
  MY_PATIENTS_BIO_INFO_PATIENT_INFO,
} from 'utilities/routes';

import Loader from 'components/loaderComponent';
import ButtonComponent from 'components/button/buttonComponent';
import { AppointmentTypeEnum } from 'graphql/generated/hasura';
import { Link } from 'react-router-dom';
import { formatDateForAppointment } from 'utilities/functions';

interface IUnfilledSummaryAppointmentCardProps {
  appointment: UnfilledSummaryAppointment;
  handleNavigateCompleteSummaryModal: (appointmentId: string) => void;
  locale: Record<string, string>;
}

const UnfilledSummaryAppointmentCard: React.FC<
  IUnfilledSummaryAppointmentCardProps
> = ({ appointment, handleNavigateCompleteSummaryModal, locale }) => {
  const { name, appointmentId } = appointment;

  const appointmentWithText = [
    AppointmentTypeEnum.Video,
    AppointmentTypeEnum.Video_30,
    AppointmentTypeEnum.Video_60,
  ].includes(appointment.appointmentType)
    ? locale.videoAppointmentWith
    : locale.chatAppointmentWith;

  if (!locale) return <Loader />;

  return (
    <div className="w-full">
      <div className="flex flex-col desktop:flex-row desktop:items-center justify-between desktop:px-30 desktop:py-5 px-5 py-3 border border-gray-opacity-15 bg-neutral-100 rounded-xl">
        <div className="flex flex-col mb-5 desktop:mb-0">
          <div className="bg-neutral-100">
            <div className="text-base font-semibold text-neutral-800">
              <span className="whitespace-nowrap">{appointmentWithText}</span>
              <Link
                target="_blank"
                rel="noopener noreferrer"
                className="ml-1 text-base text-clc-blue font-semibold underline"
                to={`${MY_PATIENTS}/${appointment.patientId}/${MY_PATIENTS_BIO_INFO}/${MY_PATIENTS_BIO_INFO_PATIENT_INFO}`}
              >
                {name}
              </Link>
            </div>
          </div>
          <div>
            <span className="text-sm text-neutral-500">
              {formatDateForAppointment(appointment.date, {
                simplified: true,
                withTimeZone: true,
              })}
            </span>
          </div>
        </div>

        <div className="col-span-3 w-full desktop:w-auto flex items-center justify-end">
          <ButtonComponent
            className="!text-sm rounded !px-3 ml-auto block wihtespace-nowrap"
            desktopFullWidth
            onClick={() => handleNavigateCompleteSummaryModal(appointmentId)}
            testID={`complete-summary-appointment-${appointmentId}-button`}
          >
            {locale?.completeSummary}
          </ButtonComponent>
        </div>
      </div>
    </div>
  );
};

export default UnfilledSummaryAppointmentCard;
